import React, { useEffect, useState } from "react";
import { matchPath } from "react-router-dom";
import { setUrls, systemCode, urls } from "../..";
import { appConfig } from "../../appConfig";
import { getQueryStringVariable } from '../../data/utils/getQueryStringVariable';
import { SeoContext, useSeoContext } from "../../data/seo/SeoContextProvider";
import { fetchSeoConfig } from '../../data/seo/seoUtils';
import { load_xs_routes } from "./xrouter/seoUtils";
import { removeMultipleSlashes } from "../../data/sport-utils";
import { getConfiguration } from "../../data/utils/configuration";

export const XSeoContext = React.createContext(null);

function XSeoConf(props) {
    const conf = getConfiguration();
    const [seoContentContext] = useSeoContext();
    const [xseoContext, setXseoContext] = useState({
        seoConfigFetched:false,
        urlsReady:false,
        seoRealPathname:null,
        update(updt) {
            setXseoContext(prev => {
                return {...prev, ...updt};
            });
        },
        setSeoConfigFetched: function(seoConfigFetched) {
            this.update ({seoConfigFetched});
        },
        setUrlsReady: function(urlsReady) {
            this.update ({urlsReady});
        },
        setSeoRealPathname: function(seoRealPathname) {
            this.update ({seoRealPathname});
        }
    });

    function setSeoConfigFetched() {
        xseoContext.setSeoConfigFetched(true);
    }

    function isSeoOff() {
        return (getQueryStringVariable('seoOff') === 'true' || getQueryStringVariable('seoDisabled') === 'true' || (appConfig && appConfig['seoOff'] === true)) ? true : false;
    }

    useEffect(function() {
        if ((!(window.cg_SYSTEM_CODE || window.appConfig.SHOP_MODE ) && !isSeoOff() ) || (appConfig && appConfig['SEO_ENABLED'])) {
            try {
                fetchSeoConfig(setSeoConfigFetched, true);
            } catch(err) {
                setSeoConfigFetched(true);
                console.log(err);
                alert(err);
            }
        } else {
            setSeoConfigFetched(true);
        }
    }, []);

    useEffect(function() {
       if(xseoContext.seoConfigFetched) {
            if(appConfig.ROUTES['race-sport']?.['race-sport']) {
                if(conf?.xrc?.customUrl) {
                    appConfig.ROUTES['race-sport']['race-sport'] = conf?.xrc?.customUrl;
                }
            }else{
                    appConfig.ROUTES['race-sport'] = {'race-sport':(conf?.xrc?.customUrl || '/race-sport')}
            }
            
            load_xs_routes(systemCode);
            setUrls( window.xs_routes[systemCode] || window.xs_routes['DEFAULT']);
            xseoContext.setUrlsReady(true);
       }
    }, [xseoContext.seoConfigFetched]);

    useEffect(() => {
        if(xseoContext.seoRealPathname) {
            const path = xseoContext.seoRealPathname;
        
            const basePrematch =  matchPath({
                path: removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`),
                end: false,
                caseSensitive: false
            },path);
        
            const baseLive =  matchPath({
                path: removeMultipleSlashes(`${urls.base}/${urls.live.base}`),
                end: false,
                caseSensitive: false
            },path);

            const baseSportHome =  matchPath({
                path: removeMultipleSlashes(`${urls.base}/${urls['sport-home']?.['sport-home']}`),
                end: false,
                caseSensitive: false
            },path);

            const baseRaceSport =  matchPath({
                path: removeMultipleSlashes(`${urls.base}/${urls['race-sport']?.['race-sport']}`),
                end: false,
                caseSensitive: false
            },path);
           
            const baseFavoriteOdds =  matchPath({
                path: removeMultipleSlashes(`${urls['favorite-odds']}`),
                end: false,
                caseSensitive: false
            },path);

            const baseTodayOdds =  matchPath({
                path: removeMultipleSlashes(`${urls['today-odds']}`),
                end: false,
                caseSensitive: false
            },path);

            const baseCalendar =  matchPath({
                path: removeMultipleSlashes(`${urls['calendar']}`),
                end: false,
                caseSensitive: false
            },path);

             const baseMybets =  matchPath({
                path: removeMultipleSlashes(`${urls['mybets']}`),
                end: false,
                caseSensitive: false
            },path);

            const baseCheckbet =  matchPath({
                path: removeMultipleSlashes(`${urls['checkbet']}`),
                end: false,
                caseSensitive: false
            },path);
    
            const section = baseLive?.pathname?'live': 
                            baseCalendar?.pathname?'calendar': 
                            baseFavoriteOdds?.pathname?'favorite-odds':
                            baseTodayOdds?.pathname?'today-odds':
                            baseMybets?.pathname?'mybets':
                            baseCheckbet?.pathname?'checkbet':
                            basePrematch?.pathname?'prematch':
                            baseSportHome?.pathname?'sport-home':
                            baseRaceSport?.pathname?'race-sport':
                            'prematch';       
            seoContentContext.refreshPathname(path,section);

            document.querySelector('body')?.setAttribute("data-xsport-section",section);

        }
       
            
    }, [xseoContext.seoRealPathname]);


    return (xseoContext.seoConfigFetched && xseoContext.urlsReady && 
        <XSeoContext.Provider value={xseoContext}>
             <SeoContext.Provider value={seoContentContext}>
                 {props.children}
            </SeoContext.Provider>
        </XSeoContext.Provider>
    );

}

export default XSeoConf;